export default __webpack_public_path__ + "static/media/R870_1.acb0ebcc.png";